/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Clinical_NutritionInputs */

const en_service_type_clinical_nutrition = /** @type {(inputs: Service_Type_Clinical_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clinical nutrition`)
};

const pl_service_type_clinical_nutrition = /** @type {(inputs: Service_Type_Clinical_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dietoterapia`)
};

/**
* | output |
* | --- |
* | "Clinical nutrition" |
*
* @param {Service_Type_Clinical_NutritionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_clinical_nutrition = /** @type {((inputs?: Service_Type_Clinical_NutritionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Clinical_NutritionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_clinical_nutrition(inputs)
	return en_service_type_clinical_nutrition(inputs)
});